<div class="alert-notice" [ngClass]="'alert-notice--' + variant">
  <fa-icon class="alert-notice__icon" [icon]="icon | faIconName : 'fass'"></fa-icon>
  <p class="alert-notice__text">{{ message | translate : messageParams }}</p>
</div>
